import React, { useContext, useMemo } from 'react';
import FormRadio from '../../../../../../../../../widgets/form/components/form-radio/FormRadioCircles/FormRadioCircles';
import { options, pageSettings } from '../../../initData';
import GroupFormComponent from '../../../../../../../../../widgets/form/GroupFormComponent/GroupFormComponent';
import FormSponsorWidget from '../../../../../../../../../widgets/form/components/form-sponsor-widget/FormSponsorWidget';
import FormCheckbox from '../../../../../../../../../widgets/form/components/form-checkbox/FormCheckbox/FormCheckbox';
import { LangContext } from '../../../../../../../../../common/decorators/Language';
import T, { t } from '../../../../../../../../../common/components/T';
import { API_SERVER_URL } from '../../../../../../../../../common/utils/utils';
import { UserProfileContext } from '../../../../../../../../../common/utils/getContext';
import uikit from '../../../../../../../../../project/uikit/uikit.module.scss';
import css from './Contacts.module.scss';
import classnames from 'classnames';

const CartContacts = ({
    newUser,
    setFormDataMain,
    setNewUser,
    storeFormData,
    formStyles,
    formDataError,
    storeData,
    userData
}) => {
    const { profileData } = useContext(UserProfileContext) || {};
    const compStyles = useMemo(() => {
        const accum = {};
        Object.keys(formStyles)?.forEach((attribute) => {
            accum[attribute] = {
                ...formStyles[attribute],
                wrapper: classnames(css.formControlWrap, formStyles[attribute]?.wrapper)
            };
        });
        return accum;
    }, [formStyles]);
    const { translation } = useContext(LangContext);

    return (
        <div className={css.CartContacts}>
            {!profileData && (
                <div>
                    <FormRadio
                        attribute='statusUser'
                        disabled={false}
                        title=''
                        handlers={{
                            onChange: (a, v) => {
                                setNewUser(Number(v));
                            }
                        }}
                        value={newUser}
                        setFormData={setFormDataMain}
                        compStyle={{
                            itemWrapper: classnames(uikit.flexRow, uikit.flexWrap),
                            radio: uikit.mr3
                        }}
                        options={options.statusUser}
                    />
                </div>
            )}

            {/* <div>
                <div
                    className={classnames(css.formInfoChangeWrapper, uikit.tiny)}
                    style={{
                        color: 'var(--greySuperDarkColor)',
                        display: 'flex'
                    }}
                >
                    <div
                        style={{
                            display: 'block',
                            marginRight: '5.33px',
                            marginTop: '3px'
                        }}
                    >
                        {svgSprite('info-circle', {
                            width: '13.33px',
                            height: '13.33px',
                            fill: 'var(--greySuperDarkColor)'
                        })}
                    </div>
                    {t(
                        'storeCartContactInfo',
                        'Чтобы изменить свои контактные данные, вы можете перейти на страницу Профиль или установить чекбокс «Данные покупателя и получателя разные» и указать данные получателя',
                        '/store',
                        translation
                    )}
                </div>
            </div> */}
            <div className={css.formSponsorWidget}>
                {newUser === 1 && (
                    <FormSponsorWidget
                        attribute='sponsor_name'
                        disabled={false}
                        handlers={{}}
                        value={storeData['sponsor_name']}
                        setFormData={setFormDataMain}
                        type='text'
                        variation={'no_title'}
                        placeholder={t('storeLoginSponsor', 'Укажите логин спонсора', '/store', translation)}
                        errors={formDataError['sponsor_name']}
                    />
                )}
            </div>
            <div>
                {!!storeData.statusUser && newUser === 1 && (
                    <FormCheckbox
                        attribute='newuser_agree'
                        disabled={false}
                        title={{
                            body: (
                                <T
                                    textName='storeAccessRegister'
                                    defaultStr='Подтверждаю свое согласие на регистрацию в системе после оплаты заказа'
                                    page='/store'
                                />
                            )
                        }}
                        handlers={{}}
                        value={'1'}
                        setFormData={setFormDataMain}
                        errors={formDataError['newuser_agree']}
                    />
                )}
            </div>
            {/* <div>
                <FormCheckbox
                    attribute='recipient_type'
                    disabled={false}
                    title={{
                        body: <T textName='storeDataDifferent' defaultStr='Данные покупателя и получателя разные' page='/store' />
                    }}
                    handlers={{}}
                    value={storeData.recipient_type === 'me' ? '0' : '1'}
                    setFormData={setFormDataMain}
                    compStyle={{ wrapper: storeData.recipient_type !== 'me' ? css.recipientFull : '' }}
                />
            </div> */}
            <div>
                <GroupFormComponent
                    context={false}
                    user={userData}
                    data={storeFormData}
                    formStyles={compStyles}
                    setFormDataMain={setFormDataMain}
                    formDataMain={false}
                    sendData={{
                        url: `${API_SERVER_URL}/api/v1/admin/shop/product-categories`
                    }}
                    message={{
                        success: t('storeOrderSuccessful', 'Заказ успешно сохранен', '/store', translation),
                        error: false
                    }}
                    customStyles={css}
                    customData={{ fieldsWrapper: css.storeformGlobWrap }}
                    pageSettings={pageSettings}
                    formDataError={formDataError}
                    buttonNotShow
                />
            </div>
        </div>
    );
};
export default CartContacts;
